module.exports = __webpack_public_path__ + "static/media/logo-sm-light.594b90d3.svg";